import {createSlice} from "@reduxjs/toolkit";

const initialGuiPatentsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  guiPatentForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const guiPatentsSlice = createSlice({
  name: "guiPatents",
  initialState: initialGuiPatentsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getGuiPatentById
    guiPatentFetched: (state, action) => {
      state.actionsLoading = false;
      state.guiPatentForEdit = action.payload.guiPatentForEdit;
      state.error = null;
    },
    // findGuiPatents
    guiPatentsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createGuiPatent
    guiPatentCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.guiPatent);
    },
    // updateGuiPatent
    guiPatentUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.guiPatentId === action.payload.guiPatent.guiPatentId) {
          return action.payload.guiPatent;
        }
        return entity;
      });
    },
    // deleteGuiPatent
    guiPatentDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.guiPatentId !== action.payload.guiPatentId);
    },
    // deleteGuiPatents
    guiPatentsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.guiPatentId)
      );
    },
  }
});
